"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChart = void 0;
var React = __importStar(require("react"));
var common_1 = require("../common");
var recharts_1 = require("recharts");
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../utils");
var theme_1 = require("@epic-visualizations/theme");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            width: "100%",
            height: "100%",
            display: "flex",
        },
        chart: { flex: 5 },
        legend: {
            flex: 4,
            padding: spacing(0, 4, 2),
            alignSelf: "center",
        },
        layoutVertical: {
            flexDirection: "column",
            "& $legend": {
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                marginTop: spacing(-3),
            },
        },
        layoutHorizontal: {
            flexDirection: "row",
            "& $chart": {
                display: "flex",
                alignItems: "center",
            },
            "& $legend": {
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                justifyContent: "center",
                marginLeft: spacing(-4),
                padding: spacing(0, 4, 0, 0),
            },
        },
        mirrored: {
            "&$layoutVertical": {
                flexDirection: "column-reverse",
                "& $legend": {
                    marginTop: 0,
                    marginBottom: spacing(-3),
                },
            },
            "&$layoutHorizontal": {
                flexDirection: "row-reverse",
                "& $chart": {
                    justifyContent: "flex-end",
                },
                "& $legend": {
                    marginLeft: 0,
                    marginRight: spacing(-4),
                    padding: spacing(0, 0, 0, 4),
                },
            },
        },
        sizeLong: {
            alignItems: "center",
            "& $chart": {
                flex: 4,
                marginRight: spacing(4),
            },
            "& $legend": {
                flex: 6,
            },
        },
    });
});
var PieChart = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.dataKey, dataKey = _f === void 0 ? "value" : _f, _g = _a.data, data = _g === void 0 ? [] : _g, _h = _a.animate, animate = _h === void 0 ? false : _h, _j = _a.responsive, responsive = _j === void 0 ? true : _j, width = _a.width, height = _a.height, minWidth = _a.minWidth, minHeight = _a.minHeight, locales = _a.locales, _k = _a.hideTooltip, hideTooltip = _k === void 0 ? false : _k, tooltipFormatterOptions = _a.tooltipFormatterOptions, _l = _a.tooltipFormatter, tooltipFormatter = _l === void 0 ? (0, utils_1.numberFormatter)(locales, tooltipFormatterOptions) : _l, tooltipMinWidth = _a.tooltipMinWidth, valueFormatterOptions = _a.valueFormatterOptions, _m = _a.valueFormatter, valueFormatter = _m === void 0 ? (0, utils_1.numberFormatter)(locales, valueFormatterOptions) : _m, _o = _a.hideLegend, hideLegend = _o === void 0 ? false : _o, _p = _a.legendLayout, legendLayout = _p === void 0 ? "vertical" : _p, _q = _a.legendSize, legendSize = _q === void 0 ? "normal" : _q, _r = _a.mirrored, mirrored = _r === void 0 ? false : _r, _s = _a.pieProps, pieProps = _s === void 0 ? {} : _s, cellProps = _a.cellProps, sectorProps = _a.sectorProps, tooltipProps = _a.tooltipProps, responsiveContainerProps = _a.responsiveContainerProps, onLegendMouseEnter = _a.onLegendMouseEnter, onLegendMouseLeave = _a.onLegendMouseLeave, _t = _a.innerRadius, innerRadius = _t === void 0 ? "50%" : _t, tooltipContent = _a.tooltipContent, _u = _a.LegendComponent, LegendComponent = _u === void 0 ? common_1.VerticalLegend : _u, children = _a.children, restProps = __rest(_a, ["dataKey", "data", "animate", "responsive", "width", "height", "minWidth", "minHeight", "locales", "hideTooltip", "tooltipFormatterOptions", "tooltipFormatter", "tooltipMinWidth", "valueFormatterOptions", "valueFormatter", "hideLegend", "legendLayout", "legendSize", "mirrored", "pieProps", "cellProps", "sectorProps", "tooltipProps", "responsiveContainerProps", "onLegendMouseEnter", "onLegendMouseLeave", "innerRadius", "tooltipContent", "LegendComponent", "children"]);
    var getComparisonColor = (0, theme_1.useComparisonColor)();
    var classes = useStyles();
    var _v = pieProps.startAngle, startAngle = _v === void 0 ? -75 : _v, _w = pieProps.endAngle, endAngle = _w === void 0 ? 285 : _w, activeIndex = pieProps.activeIndex, _x = pieProps.nameKey, nameKey = _x === void 0 ? "name" : _x, restPieProps = __rest(pieProps, ["startAngle", "endAngle", "activeIndex", "nameKey"]);
    var cells = data.map(function (_a, index) {
        var color = _a.color;
        var fill = getComparisonColor(color !== null && color !== void 0 ? color : index);
        return (React.createElement(recharts_1.Cell, __assign({ key: "cell_" + index, fill: fill, stroke: "transparent" }, cellProps)));
    });
    var chart = (React.createElement(recharts_1.PieChart, __assign({ width: width, height: height, margin: { top: 2, right: 2, bottom: 2, left: 2 } }, restProps),
        React.createElement(recharts_1.Pie, __assign({ isAnimationActive: animate, dataKey: dataKey, data: data, innerRadius: innerRadius, startAngle: startAngle, endAngle: endAngle, labelLine: false, label: false, activeIndex: activeIndex, activeShape: function (_a) {
                var innerRadius = _a.innerRadius, outerRadius = _a.outerRadius, props = __rest(_a, ["innerRadius", "outerRadius"]);
                return (React.createElement(recharts_1.Sector, __assign({ innerRadius: innerRadius - 3, outerRadius: outerRadius + 3 }, props, sectorProps)));
            }, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref: restPieProps === null || restPieProps === void 0 ? void 0 : restPieProps.ref }, restPieProps), cells),
        !hideTooltip && data.length > 0 && (React.createElement(recharts_1.Tooltip, __assign({ content: React.createElement(common_1.CustomTooltip, { formatter: tooltipFormatter, minWidth: tooltipMinWidth, hideLabel: true, tooltipContent: tooltipContent }), cursor: false, separator: ": " }, tooltipProps))),
        children));
    var withResponsive = responsive ? (React.createElement(recharts_1.ResponsiveContainer, __assign({ minWidth: minWidth, minHeight: minHeight }, responsiveContainerProps), chart)) : (chart);
    return (React.createElement("div", { className: (0, clsx_1.default)(classes.root, (_b = {}, _b[classes.layoutVertical] = legendLayout === "vertical", _b), (_c = {}, _c[classes.layoutHorizontal] = legendLayout === "horizontal", _c), (_d = {}, _d[classes.sizeLong] = legendSize === "long", _d), (_e = {}, _e[classes.mirrored] = mirrored, _e)) },
        React.createElement("div", { className: classes.chart }, withResponsive),
        !hideLegend && (React.createElement("div", { className: classes.legend },
            React.createElement(LegendComponent, { data: data, nameKey: nameKey, dataKey: dataKey, valueFormatter: valueFormatter, onLegendMouseEnter: onLegendMouseEnter, onLegendMouseLeave: onLegendMouseLeave })))));
};
exports.PieChart = PieChart;
//# sourceMappingURL=PieChart.js.map